const sandbox = require('./sandbox.json');
const production = require('./production.json');

const environmentVariables = {
    sandbox,
    production
};

const environment = WEBPACK_ENV;

module.exports = {
    ...(environment === 'development' ? environmentVariables.sandbox : environmentVariables.production)
};



// WEBPACK FOOTER //
// ./config/config.js